import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "truncated-cell__tooltip" }

import { ref, computed, onMounted } from "vue";

interface Props {
  tooltipText?: string;
  showTooltip?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TruncatedCell',
  props: {
    tooltipText: { default: "" },
    showTooltip: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const contentRef = ref<HTMLElement | null>(null);
const isTruncated = ref(false);

const checkTruncation = () => {
  if (contentRef.value) {
    isTruncated.value = contentRef.value.scrollWidth > contentRef.value.clientWidth;
  }
};

onMounted(() => {
  checkTruncation();
});

return (_ctx: any,_cache: any) => {
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createBlock(_component_VTooltip, {
    disabled: !__props.showTooltip || !isTruncated.value
  }, {
    popper: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "tooltip", {}, () => [
          _createTextVNode(_toDisplayString(__props.tooltipText), 1)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "contentRef",
        ref: contentRef,
        class: "truncated-cell",
        onMouseenter: checkTruncation
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 544)
    ]),
    _: 3
  }, 8, ["disabled"]))
}
}

})